import { HTMLAttributes } from "react";

export default function Flutter(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2483_1792)">
        <path
          d="M4.61255 24.075L28.6125 0H43.3875L12.0375 31.35L4.61255 24.075ZM28.6125 48H43.3875L30.6 35.2125L43.3875 22.1625H28.6125L15.825 35.0625L28.6125 48Z"
          fill="#3FB6D3"
        />
        <path
          d="M30.6 35.2125L23.1 27.7125L15.825 35.0625L23.1 42.4125L30.6 35.2125Z"
          fill="#27AACD"
        />
        <path
          d="M43.3876 48L30.6001 35.2125L23.1001 42.4125L28.6126 48H43.3876Z"
          fill="#19599A"
        />
        <path
          d="M23.1001 42.4125L34.6501 39.2625L30.6001 35.2125L23.1001 42.4125Z"
          fill="url(#paint0_linear_2483_1792)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2483_1792"
          x1="22.262"
          y1="43.635"
          x2="32.5595"
          y2="37.2746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B4E94" />
          <stop offset="0.63" stopColor="#1A5497" />
          <stop offset="1" stopColor="#195A9B" />
        </linearGradient>
        <clipPath id="clip0_2483_1792">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
